import { MODAL, LANGUAGE } from "./types";

const initialState = {
	modalIsOpen: false,
	content: {
		description: "",
		id: null,
		image: "",
		price: "",
		text: ""
	},
}

export const modal = ( state = initialState, action) => {
	const { type, payload } = action
	switch (type ) {
		case MODAL.SET_MODAL_OPEN : {
			return {...state, modalIsOpen: true, content: payload}
		}
		case MODAL.SET_CLOSE_MODAL : {
			return {...state, ...initialState}
		}
		default: {
			return state;
		}
	}
};

export const language = (state = "ru", action) => {
	const { type, payload } = action;
	switch ( type) {
		case LANGUAGE.SET_LANGUAGE : return payload;
		default: return state
	}
}
